// Stormrock — tiroir panier instantané (correctif mobile, 28/10/2026)
//
// Constat : un ajout au panier met 1,5 à 2,5 s à revenir de Shopify (calcul du
// panier côté serveur + l'appli EasyGift qui relit le panier avant de rendre la
// main). Le tiroir ne s'ouvrait qu'ensuite, et la photo de l'article ne commençait
// à se télécharger qu'à l'ouverture : carré blanc ou photo à moitié chargée.
//
// Correctif :
//  1. au clic sur « Ajouter », le tiroir s'ouvre tout de suite avec une ligne
//     « Ajout en cours » (photo, nom, format) ;
//  2. la photo est préchargée à la taille exacte qu'utilise le tiroir
//     (cart-products.liquid : image_url width 300), elle est donc déjà en cache ;
//  3. quand Shopify répond (événement cart:update du thème), la ligne provisoire
//     s'efface et le vrai contenu du panier apparaît ;
//  4. en cas d'erreur (rupture, quantité max…), le tiroir se referme pour laisser
//     voir le message d'erreur du thème sur la fiche produit.
//
// Mêmes règles pour les boutons « Ajouter » du slider Halloween (sr-halloween-offer.js),
// qui n'utilisent pas de formulaire. Filet de sécurité : toute photo du tiroir qui ne
// s'est pas chargée est rechargée (Safari peut ne pas charger une image insérée par le
// morph du thème, qui vient d'un document DOMParser).
//
// EasyGift : avant chaque ajout, l'appli demande à son serveur le prix du produit
// (0,5 à 1,4 s), sauf si window.EG_INFO[variante] existe et a moins de 300 s. La page ne
// le remplit que pour la fiche produit ouverte : on le complète (prix exacts rendus par
// Shopify) et on rafraîchit sa date dès que le doigt touche l'écran.
//
// Masque aussi la pastille Klaviyo « Pssst ! 10€ offerts ! » (formulaire XrFcYx).
(() => {
  const THUMB_WIDTH = 300;
  const SAFETY_MS = 20000;
  let pending = null; // { token, undo, timer, watch, wantCheckout }

  /* ---------- Message de Shopify quand un ajout est refusé ---------- */

  // Exemple : « La quantité maximale de cet article est déjà dans votre panier. »
  let lastAddError = '';
  const baseFetch = window.fetch;
  window.fetch = function (input) {
    const url = String((input && input.url) || input || '');
    const request = baseFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      lastAddError = '';
      request
        .then((response) => {
          if (response.ok) return;
          response
            .clone()
            .json()
            .then((json) => {
              lastAddError = (json && (json.description || json.message)) || '';
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
    return request;
  };

  const noteStyle = document.createElement('style');
  noteStyle.textContent =
    '.sr-cart-note{position:absolute;left:16px;right:16px;top:64px;z-index:21;padding:12px 14px;' +
    'border-radius:8px;background:#111;color:#fff;font-size:14px;line-height:1.35;' +
    'box-shadow:0 6px 20px rgb(0 0 0/.25);animation:sr-cart-adding-in .12s ease-out}';
  document.head.appendChild(noteStyle);

  // Ajout refusé : on retire la ligne provisoire, le tiroir montre le vrai panier
  // (inchangé) et le message de Shopify pendant 5 s. Plus de fermeture brutale.
  function showAddError() {
    clearPending(true);
    setTimeout(() => {
      const dialog = document.querySelector('cart-drawer-component dialog');
      if (!dialog || !dialog.open) return;
      dialog.querySelectorAll('.sr-cart-note').forEach((n) => n.remove());
      const note = document.createElement('div');
      note.className = 'sr-cart-note';
      note.setAttribute('role', 'alert');
      note.textContent = lastAddError || "Ce produit n'a pas pu être ajouté au panier.";
      dialog.append(note);
      setTimeout(() => note.remove(), 5000);
    }, 80);
  }

  /* ---------- Photo : même URL que le tiroir ---------- */

  function thumbUrl(raw) {
    if (!raw) return '';
    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.set('width', String(THUMB_WIDTH));
      // même forme que image_url de Shopify : //domaine/chemin?v=…&width=300
      return '//' + url.host + url.pathname + url.search;
    } catch (e) {
      return '';
    }
  }

  function preload(src) {
    if (!src) return;
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  /* ---------- Infos produit à partir du formulaire ---------- */

  function productInfo(form) {
    const component = form.closest('product-form-component');
    // Carte produit (accueil, collections, carrousels) ou section de la fiche produit.
    const card = form.closest('product-card, .product-card');
    const scope = card || form.closest('.shopify-section') || document;
    const media = component && component.querySelector('[data-product-variant-media]');
    const raw = media ? media.getAttribute('data-product-variant-media') : '';

    let title = '';
    // Sur une carte, le titre est un bloc texte « product_title » (h3) : surtout pas le h1 de la page.
    const titleEl = card
      ? card.querySelector('[class*="product_title"], .product-card__title, h3, .h4')
      : scope.querySelector('.product-card__title, [class*="product-title"] h1, h1, .product-title') ||
        document.querySelector('h1');
    if (titleEl) title = titleEl.textContent.replace(/\s+/g, ' ').trim();

    let variant = '';
    const idInput = form.querySelector('[name="id"]');
    // Carte : le format est un <select name="options[…]"> de la carte, hors du formulaire.
    const select =
      (card && card.querySelector('select')) ||
      (component && component.querySelector('select[name="id"], select.variant-select, variant-picker select'));
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      variant = select.selectedOptions[0].textContent;
    } else {
      // Sélecteur Stormrock en tuiles (3G, 5G…) : il vit hors du formulaire, dans la section.
      const section = card || form.closest('.shopify-section') || document;
      const checked =
        section.querySelector('[class*="variant-picker"] input:checked, variant-picker input:checked') ||
        (component || document).querySelector('input[type="radio"]:checked');
      if (checked) variant = checked.value || '';
    }
    variant = variant.replace(/\s+/g, ' ').trim();
    // « 5g ⎼ 7,00€/g » (sélecteur des cartes) → « 5g », comme sur la fiche produit.
    variant = variant.split(/\s[⎼–—-]\s/)[0]; if (variant.length > 24) variant = variant.split(' ')[0];

    // Photo déjà affichée sur la page (donc déjà téléchargée) pour la ligne provisoire.
    let shown = '';
    const imgs = scope.querySelectorAll(
      'img.product-media__image, media-gallery img, .product-media img, slideshow-slide img, .card-gallery img, product-card img'
    );
    for (const img of imgs) {
      if (img.complete && img.naturalWidth > 0 && img.getBoundingClientRect().width > 40) {
        shown = img.currentSrc || img.src;
        break;
      }
    }

    const src = thumbUrl(raw);
    const id = idInput ? idInput.value : '';
    // Prix exact : grammage choisi sur la carte (data-price, centimes), sinon EG_INFO.
    let cents = NaN;
    const opt = select && select.selectedOptions && select.selectedOptions[0];
    if (opt && opt.dataset.price) cents = parseInt(opt.dataset.price, 10);
    if (!Number.isFinite(cents)) cents = egCents(id);
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
    const url = (component && component.dataset.productUrl) || '';
    return { src, shown: shown || src, title, variant, id, cents, qty, url };
  }

  function egCents(id) {
    const e = window.EG_INFO && window.EG_INFO[String(id)];
    if (!e) return NaN;
    if (typeof e.price === 'number') return e.price; // déjà converti en centimes par EasyGift
    const v = parseFloat(String(e.price).replace(',', '.'));
    return Number.isFinite(v) ? Math.round(v * 100) : NaN;
  }

  /* ---------- Panier complet affiché tout de suite ---------- */

  // Au clic, le tiroir montre le vrai panier, avec le nouvel article en tête, le nombre
  // d'articles, le sous-total et le bouton de paiement. Quand Shopify répond (1 à 2 s),
  // le thème remplace ce contenu par le sien : seuls les montants exacts s'ajustent.

  function money(cents) {
    const [int, dec] = (Math.max(0, cents) / 100).toFixed(2).split('.');
    return int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec + '€';
  }

  function parseMoney(text) {
    const m = String(text || '').replace(/\s| | /g, '').match(/(-?[\d.]+),(\d{2})/);
    return m ? parseInt(m[1].replace(/\./g, '') + m[2], 10) : NaN;
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  // Même balisage et mêmes classes que snippets/cart-products.liquid (donc même rendu),
  // sans composants interactifs : la ligne est inerte jusqu'à la réponse de Shopify.
  function rowHtml(info) {
    const img = info.shown || info.src;
    const price = Number.isFinite(info.cents) ? money(info.cents * info.qty) : '';
    return (
      '<tr role="row" class="cart-items__table-row sr-opt-row" inert>' +
      '<td class="cart-items__media" role="cell"><span class="cart-items__media-container" style="--ratio:1;">' +
      (img ? '<img src="' + esc(img) + '" alt="" width="300" height="300" loading="eager" class="cart-items__media-image border-style">' : '') +
      '</span></td>' +
      '<td class="cart-items__details cart-primary-typography" role="cell"><p><span class="cart-items__title">' +
      esc(info.title) + '</span></p>' +
      (info.variant ? '<dl class="cart-items__variants"><div class="cart-items__variant"><dd>' + esc(info.variant) + '</dd></div></dl>' : '') +
      '</td>' +
      '<td class="cart-items__quantity" role="cell"><div class="quantity-selector cart-primary-typography">' +
      '<span class="button quantity-minus button-unstyled" aria-hidden="true">−</span>' +
      '<input type="number" value="' + info.qty + '" aria-label="Quantité" disabled>' +
      '<span class="button quantity-plus button-unstyled" aria-hidden="true">+</span></div></td>' +
      '<td class="cart-items__price cart-secondary-typography" role="cell"><span>' + price + '</span></td>' +
      '</tr>'
    );
  }

  function headingText(count) {
    return count + (count > 1 ? ' articles' : ' article');
  }

  // Modifie le tiroir et renvoie la fonction qui annule tout (si l'ajout est refusé).
  function showOptimisticCart(info) {
    const ci = document.querySelector('cart-drawer-component cart-items-component');
    if (!ci) return () => {};
    // Stormrock — nouveau cart drawer (sr-cart.js) : il gère lui-même la ligne provisoire.
    if (window.SRCart && window.SRCart.optimistic && ci.querySelector('.sr-cart')) return window.SRCart.optimistic(info);
    const undo = [];
    const setText = (el, text) => {
      if (!el) return;
      const before = el.textContent;
      el.textContent = text;
      if (el.hasAttribute('value')) {
        const v = el.getAttribute('value');
        el.setAttribute('value', text);
        undo.push(() => el.setAttribute('value', v));
      }
      undo.push(() => (el.textContent = before));
    };
    const add = Number.isFinite(info.cents) ? info.cents * info.qty : NaN;
    const tbody = ci.querySelector('table.cart-items__table tbody');

    if (tbody && tbody.querySelector('tr.cart-items__table-row')) {
      // Panier déjà rempli : même variante → quantité +1, sinon nouvelle ligne en tête.
      const same = [...tbody.querySelectorAll('tr.cart-items__table-row[data-key]')].find(
        (r) => r.dataset.key.split(':')[0] === String(info.id) && !r.dataset.parentKey
      );
      if (same) {
        const input = same.querySelector('input[name="updates[]"], input[type="number"]');
        if (input) {
          const v = input.value;
          input.value = String((parseInt(v, 10) || 0) + info.qty);
          undo.push(() => (input.value = v));
        }
        const priceEl = same.querySelector('.cart-items__price text-component, .cart-items__price > span');
        const cur = priceEl ? parseMoney(priceEl.textContent) : NaN;
        if (Number.isFinite(cur) && Number.isFinite(add)) setText(priceEl, money(cur + add));
      } else {
        tbody.insertAdjacentHTML('afterbegin', rowHtml(info));
        const row = tbody.firstElementChild;
        undo.push(() => row.remove());
      }
      const heading = ci.querySelector('.cart-drawer__heading');
      const n = heading ? parseInt(heading.textContent, 10) : NaN;
      if (Number.isFinite(n)) setText(heading, headingText(n + info.qty));
      if (Number.isFinite(add)) {
        ['.cart__original-total-value', '.cart__total-value'].forEach((sel) => {
          const el = ci.querySelector(sel);
          const cur = el ? parseMoney(el.textContent) : NaN;
          if (Number.isFinite(cur)) setText(el, money(cur + add));
        });
      }
    } else {
      // Panier vide : on construit le panier rempli (en-tête, ligne, sous-total, bouton).
      const dialog = ci.closest('dialog');
      const saved = [...ci.childNodes];
      const close = ci.querySelector('.cart-drawer__close-button');
      const wrap = document.createElement('div');
      wrap.innerHTML =
        '<div class="cart-drawer__header" id="cart-drawer-header"><span class="cart-drawer__heading h3">' +
        headingText(info.qty) + '</span></div>' +
        '<div class="cart-drawer__content motion-reduce" aria-label="Panier"><div class="cart-drawer__items">' +
        // .cart-form est indispensable : le thème masque la liste si le tiroir n'en a pas.
        '<div class="cart-items__wrapper"><div class="cart-form"><div class="cart-items spacing-style">' +
        '<table class="cart-items__table" role="table">' +
        '<tbody role="rowgroup">' + rowHtml(info) + '</tbody></table></div></div></div></div>' +
        '<div class="cart-drawer__summary"><div class="cart__summary-totals">' +
        (Number.isFinite(add)
          ? '<div class="cart__original-total-container cart-primary-typography"><span class="cart__summary-item cart__original-total">' +
            '<span class="cart__original-total-label">Sous-total</span>' +
            '<span class="cart__original-total-value cart-secondary-typography">' + money(add) + '</span></span></div>'
          : '') +
        '</div><div class="cart__ctas"><button type="button" class="cart__checkout-button button sr-opt-checkout">' +
        '<span class="button__text">Finaliser le paiement</span></button></div></div></div>';
      const closeParent = close && close.parentNode;
      const closeNext = close && close.nextSibling;
      if (close) wrap.querySelector('.cart-drawer__header').append(close);
      ci.replaceChildren(...wrap.childNodes);
      undo.push(() => {
        ci.replaceChildren(...saved);
        if (close && closeParent) closeParent.insertBefore(close, closeNext);
      });
      if (dialog && dialog.classList.contains('cart-drawer--empty')) {
        dialog.classList.remove('cart-drawer--empty');
        undo.push(() => dialog.classList.add('cart-drawer--empty'));
      }
    }
    return () => undo.reverse().forEach((fn) => fn());
  }

  // « Finaliser le paiement » touché avant la réponse de Shopify : on attend la fin de
  // l'ajout, puis on passe par le vrai bouton du thème (l'article n'est jamais perdu).
  document.addEventListener(
    'click',
    (event) => {
      const b = event.target instanceof Element && event.target.closest('.sr-opt-checkout');
      if (!b) return;
      event.preventDefault();
      if (pending) pending.wantCheckout = true;
      else {
        const real = document.getElementById('checkout');
        if (real) real.click();
      }
    },
    true
  );

  /**
   * @param {boolean} failed - true : l'ajout a échoué, on rétablit le panier d'avant.
   */
  function clearPending(failed) {
    if (!pending) return;
    const { timer, watch, undo, wantCheckout } = pending;
    pending = null;
    clearTimeout(timer);
    clearInterval(watch);
    if (failed && undo) undo();
    if (!failed && wantCheckout) {
      setTimeout(() => {
        const real = document.getElementById('checkout');
        if (real) real.click();
      }, 50);
    }
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const component = form.closest('product-form-component');
    if (!component) return;
    // Pas dans une fenêtre d'ajout rapide : deux fenêtres superposées seraient confuses.
    if (form.closest('dialog, quick-add-modal, .quick-add-modal')) return;

    const button = component.querySelector('[ref="addToCartButton"], button[name="add"]');
    if (button && (button.disabled || button.getAttribute('disabled') === 'true')) return;

    openInstant(productInfo(form), null);
  }

  /**
   * Ouvre le tiroir tout de suite avec la ligne « Ajout au panier… ».
   * @param {{src: string, shown: string, title: string, variant: string}} info
   * @param {HTMLElement|null} button - bouton Halloween (pour détecter son échec), sinon null
   */
  function openInstant(info, button) {
    const drawer = document.querySelector('cart-drawer-component[auto-open]');
    const dialog = drawer && drawer.querySelector('dialog');
    if (!drawer || !dialog || typeof drawer.open !== 'function') return;

    preload(info.src);

    clearPending(true);
    const token = {};
    pending = { token, undo: null, timer: setTimeout(() => clearPending(true), SAFETY_MS), watch: 0 };
    if (button) {
      // sr-halloween-offer.js n'émet pas cart:error : en cas d'échec il pose « is-error ».
      // On ne réagit qu'à une erreur posée APRÈS ce clic (l'ancienne reste 2,2 s).
      let clean = !button.classList.contains('is-error');
      pending.watch = setInterval(() => {
        if (!button.classList.contains('is-error')) {
          clean = true;
          return;
        }
        if (!clean) return;
        showAddError();
      }, 150);
    }

    // Ouvrir le tiroir fige la page 30 à 260 ms (showModal + body en position fixe).
    // Fait dans le même tour que le clic, cela retardait d'autant le départ de la
    // requête d'ajout. On laisse d'abord le thème lancer la requête, puis on ouvre.
    setTimeout(() => {
      if (!pending || pending.token !== token) return;
      try {
        pending.undo = showOptimisticCart(info);
      } catch (e) {
        pending.undo = null;
      }
      try {
        drawer.open();
      } catch (e) {
        clearPending(true);
      }
    }, 0);
  }

  document.addEventListener('submit', onSubmit, true);

  /* ---------- Slider Halloween : boutons « Ajouter » sans formulaire ---------- */

  function halloweenInfo(button) {
    const card = button.closest('[data-sr-hw-card]') || button.parentElement;
    const titleEl = card.querySelector('.sr-hw-card__title');
    const weightEl = card.querySelector('.sr-hw-card__weight');
    const img = card.querySelector('img.sr-hw-card__img, img');
    const url = img ? img.currentSrc || img.src : '';
    const ready = img && img.complete && img.naturalWidth > 0;
    return {
      // La carte affiche product.featured_image : même fichier que la vignette du tiroir.
      src: thumbUrl(url),
      // Même si la photo de la carte n'a pas fini de charger, on donne son adresse :
      // la ligne affiche une vraie photo, jamais un cadre vide.
      shown: ready ? url : url ? thumbUrl(url) : '',
      title: titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '',
      variant: weightEl ? weightEl.textContent.replace(/\s+/g, ' ').trim() : '',
      id: button.dataset.variantId || '',
      cents: (() => {
        const c = egCents(button.dataset.variantId);
        if (Number.isFinite(c)) return c;
        const el = button.querySelector('.sr-hw-card__add-price');
        return el ? parseMoney(el.textContent) : NaN;
      })(),
      qty: 1,
      url: '',
    };
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element && event.target.closest('[data-sr-hw-add]');
      if (!button || button.disabled || button.dataset.loading) return;
      openInstant(halloweenInfo(button), button);
    },
    true
  );

  /* ---------- EasyGift : informations produit fournies d'avance ---------- */

  const egPrimed = new Set();

  function egEntry(variantId, cents, productId) {
    const info = (window.EG_INFO = window.EG_INFO || {});
    const id = String(variantId || '');
    if (!id || !productId || !Number.isFinite(cents) || cents < 0) return;
    if (info[id]) return; // entrée posée par EasyGift lui-même : on n'y touche pas
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const amount = (cents / 100).toFixed(2);
    info[id] = {
      price: amount,
      presentmentPrices: { edges: [{ node: { price: { amount, currencyCode: currency } } }] },
      sellingPlanGroups: { edges: [] },
      // Ni étiquettes ni collections : si une règle EasyGift en a besoin, il ignore
      // cette entrée et interroge son serveur, comme avant.
      product: { id: 'gid://shopify/Product/' + productId },
      id,
      timestamp: Math.floor(Date.now() / 1000),
    };
    egPrimed.add(id);
  }

  function egPrimePage() {
    if (!window.EasyGift && !window.EasyGiftScriptLoaded && !document.querySelector('script[src*="506.io"]')) return;
    // Slider Halloween : prix du bouton, « 180,00€ » ou « 1.000,00 € ». On n'accepte que
    // deux décimales exactes ; sinon pas d'entrée, et EasyGift interroge son serveur.
    document.querySelectorAll('[data-sr-hw-add]').forEach((b) => {
      const el = b.querySelector('.sr-hw-card__add-price');
      const m = el && el.textContent.trim().match(/^(\d{1,3}(?:[.\s  ]?\d{3})*)[,.](\d{2})\s*€?$/);
      if (!m) return;
      const cents = parseInt(m[1].replace(/\D/g, '') + m[2], 10);
      egEntry(b.dataset.variantId, cents, b.dataset.productId);
    });
    // Cartes produit : chaque grammage du <select> porte data-variant-id et data-price.
    document.querySelectorAll('product-card[data-product-id]').forEach((card) => {
      const pid = card.getAttribute('data-product-id');
      const opts = card.querySelectorAll('option[data-variant-id][data-price]');
      if (opts.length) {
        opts.forEach((o) => egEntry(o.dataset.variantId, parseInt(o.dataset.price, 10), pid));
        return;
      }
      // Produit à un seul format : la variante est décrite dans un JSON de la carte.
      const json = card.querySelector('script[type="application/json"]');
      try {
        const v = json && JSON.parse(json.textContent);
        if (v && v.id && typeof v.price === 'number') egEntry(v.id, v.price, pid);
      } catch (e) {
        /* JSON absent ou autre : EasyGift interrogera son serveur */
      }
    });
  }

  // Une entrée de plus de 300 s est ignorée par EasyGift : on rafraîchit les dates au
  // moment du toucher, avant le clic (y compris les entrées de la fiche produit, dont la
  // date est celle du rendu de la page, parfois servie depuis le cache).
  function egRefresh() {
    const info = window.EG_INFO;
    if (!info) return;
    const now = Math.floor(Date.now() / 1000);
    Object.keys(info).forEach((k) => {
      if (info[k] && typeof info[k] === 'object' && 'timestamp' in info[k]) info[k].timestamp = now;
    });
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach((type) =>
    document.addEventListener(type, egRefresh, { capture: true, passive: true })
  );
  document.addEventListener('submit', egRefresh, true);
  document.addEventListener('click', egRefresh, true);

  function egPrimeLater() {
    const run = () => {
      try {
        egPrimePage();
      } catch (e) {
        /* sans conséquence : EasyGift garde son fonctionnement normal */
      }
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', egPrimeLater, { once: true });
  else egPrimeLater();
  // Cartes ajoutées plus tard (carrousels chargés à la demande, pagination).
  document.addEventListener('shopify:section:load', egPrimeLater);

  /* ---------- Filet de sécurité : photos du tiroir ---------- */

  function ensureDrawerImages() {
    document.querySelectorAll('cart-drawer-component img').forEach((img) => {
      if ((img.complete && img.naturalWidth > 0) || img.dataset.srRetry) return;
      // Une copie créée dans la page elle-même se charge toujours, y compris sur Safari.
      const copy = /** @type {HTMLImageElement} */ (img.cloneNode(true));
      copy.dataset.srRetry = '1';
      copy.loading = 'eager';
      img.replaceWith(copy);
    });
  }
  function checkDrawerImagesSoon() {
    setTimeout(ensureDrawerImages, 1200);
    setTimeout(ensureDrawerImages, 3500);
  }
  document.addEventListener('cart:update', checkDrawerImagesSoon);
  const drawerDialog = document.querySelector('cart-drawer-component dialog');
  if (drawerDialog) {
    new MutationObserver(() => {
      if (drawerDialog.open) checkDrawerImagesSoon();
    }).observe(drawerDialog, { attributes: true, attributeFilter: ['open'] });
  }

  // Réponse de Shopify : le thème met le tiroir à jour sur cart:update.
  document.addEventListener('cart:update', (event) => {
    if (!pending) return;
    const data = (event.detail && event.detail.data) || {};
    if (data.didError) {
      showAddError();
      return;
    }
    // Seule la réponse d'un ajout (formulaire produit ou bouton Halloween) termine l'attente.
    if (data.source !== 'product-form-component') return;
    // Le morph du thème a déjà remplacé notre contenu par le vrai panier pendant cet événement.
    setTimeout(() => clearPending(false), 30);
  });

  document.addEventListener('cart:error', () => {
    if (!pending) return;
    showAddError();
  });

  /* ---------- Pastille Klaviyo « 10€ offerts » ---------- */

  function hideKlaviyoTeaser(root) {
    const scope = root || document;
    // 1. par classe Klaviyo (kl-teaser-<id du formulaire>)
    scope.querySelectorAll('[class*="kl-teaser"]').forEach((n) => {
      if (/10\s?€\s?offerts/i.test(n.textContent || '')) n.style.setProperty('display', 'none', 'important');
    });
    // 2. par texte, si Klaviyo change ses classes : uniquement un bloc court
    //    « Pssst ! 10€ offerts ! » (la pastille), jamais le formulaire complet.
    scope.querySelectorAll('.needsclick').forEach((n) => {
      const text = (n.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length < 40 && /pssst/i.test(text) && /10\s?€/.test(text)) {
        n.style.setProperty('display', 'none', 'important');
      }
    });
  }
  // La règle CSS (cart-drawer.liquid) fait l'essentiel ; ceci rattrape un éventuel
  // changement de nom de classe chez Klaviyo. On n'observe que les enfants directs
  // de <body> (là où Klaviyo pose ses formulaires) pour ne rien coûter au reste.
  const watchBody = () =>
    new MutationObserver((muts) => {
      for (const m of muts) for (const n of m.addedNodes) if (n.nodeType === 1) hideKlaviyoTeaser(n.parentNode);
    }).observe(document.body, { childList: true });
  if (document.body) watchBody();
  else document.addEventListener('DOMContentLoaded', watchBody, { once: true });
  hideKlaviyoTeaser(document);
})();
